import { useContext, useEffect } from "react";
import TimelinePlayerContext from "../context/TimelinePlayerContext";
import getDetailsAtAbsoluteTime from "../utils/getDetailsAtAbsoluteTime";

export default function useUpdateStateFromAbsoluteTime() {
  const {
    absoluteTime,
    setComment,
    setEndTime,
    setStartTime,
    setTimelineItemId,
    setTimelineItemIndex,
    setVideoId,
    timelinePositions,
  } = useContext(TimelinePlayerContext);

  useEffect(() => {
    const { comment, endTime, id, startTime, timelineItemIndex, videoId } =
      getDetailsAtAbsoluteTime(absoluteTime, timelinePositions);

    setComment(comment);
    setEndTime(endTime);
    setStartTime(startTime);
    setTimelineItemId(id);
    setTimelineItemIndex(timelineItemIndex);
    setVideoId(videoId);
  }, [absoluteTime, timelinePositions]);
}
